import angular from 'angular';

angular
  .module('cxSettings')
  .controller('TenantCreditDialogCtrl', [
    'appUrls',
    '$http',
    'dataCache',
    'flySvc',
    tenantCreditDialogCtrl,
  ]);

function tenantCreditDialogCtrl(appUrls, $http, dataCache, flySvc) {
  var vm = this;
  vm.credits = [];
  vm.loading = true;

  vm.users = dataCache.getArray('user').map(u => ({
    userId: u.userID,
    employeeId: u.employeeID,
    name: `${u.firstName} ${u.lastName}`,
  }));

  $http.get(`${appUrls.api}/api/license/credits`).then(
    ({ data }) => {
      vm.credits = data.map(x => ({
        ...x,
        details: x.details.map(d => ({
          ...d,
          userName: vm.users.find(u => u.userId === d.userId)?.name,
        })),
      }));
      vm.loading = false;
    },
    error => {
      flySvc.error(error);
      vm.loading = false;
      return '';
    },
  );
}
